import React from 'react';

export default function AuthError() {
  const locale = global.dictionaries.calling;
  return (
    <div className="section">
      <div className="container-fluid">
        <article className="message is-danger">
          <div className="message-header">
            <p>{locale.authErrorTitle}</p>
          </div>
          <div className="message-body">
            {locale.authErrorContents}
          </div>
        </article>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/AuthError.js